var doc;
var totalPagesExp = "{total_pages_count_string}";
var logo, widthLogo, heightLogo;
var dataEvento;
var nomeEvento;
var nomeHeader;
var nomeTabela;

// var imgGrafico;
var docGrafico;

var pageContent = function (data) {

    // HEADER
    const imgData = logo;
    doc.addImage(imgData, 'png', 40, 5, widthLogo, heightLogo);

    //declaracao auditor pdf
    if (nomeHeader == 'Programa Integrado de Desenvolvimento e Qualificação de Fornecedores') {
        doc.setFontSize(18);
        doc.text(470, 50, nomeHeader, null, null, 'center');
        doc.setFontSize(15);
        doc.setFontStyle('Arial');
        doc.fromHTML(nomeEvento, 50, 75);
    } else {//reuniões
        doc.setFontSize(20);
        doc.text(350, 50, nomeHeader, null, null, 'center');
        doc.setFontSize(12);
        doc.text(550, 50, 'Data: ' + dataEvento);
        doc.setFontSize(12);
        doc.text(40, 90, 'Evento: ' + nomeEvento);
    }

    // FOOTER
    var str = "Página " + data.pageCount;
    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
        str = str + " de " + totalPagesExp;
    }
    doc.setFontSize(10);
    doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
};

exports.defImage = function (logoProdfor) {
    logo = logoProdfor;
    widthLogo = 174 * 0.65;
    heightLogo = 100 * 0.65;
}

exports.geratabela = function (colunas, dados, zerarPosY, data, nomeevento, nomeheader, nometabela) {
    dataEvento = data;
    nomeEvento = nomeevento;
    nomeTabela = nometabela;
    nomeHeader = nomeheader;

    var first = doc.autoTableEndPosY() && !zerarPosY ? doc.autoTableEndPosY() : 0;
    zerarPosY = false;

    doc.setFontSize(20);
    doc.text(300, first + 120, nomeTabela, 'center');

    doc.autoTable(colunas, dados, {
        startY: first + 130,
        addPageContent: pageContent,
        margin: {
            top: 180
        }
    });
};

exports.inicializapdf = function () {
    doc = null;
    doc = new jsPDF('landscape', 'pt');
};
exports.salvar = function (nome) {
    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp);
    }
    doc.save(nome);
};


//--------------------- PDF GRAFICO ---------------------


exports.inicializaPdfGrafico = function () {
    docGrafico = null;
    docGrafico = new jsPDF('landscape', 'pt');
};

var x = 60;
var y = 25;
/* var widthLogoGrafico = 500;
var heightLogoGrafico = 400; */


exports.geraPdfGrafico = function (titulo, imgGrafico, filtro, width, height) {
    const imgLogo = logo;
    // docGrafico.addImage(imgLogo, 'png', 40, 5, widthLogoGrafico, heightLogoGrafico);
    docGrafico.addImage(imgLogo, 'png', 40, 5);
    docGrafico.setFontSize(12);
    docGrafico.text(titulo, x + 320, y, null, null, 'center');
    docGrafico.text(x, y + 70, "Filtro: ".concat(filtro));

    const maxW = docGrafico.internal.pageSize.width;
    const maxH = docGrafico.internal.pageSize.height;
    var tamWidth = width ? width * 0.75 : 0;
    var tamHeight = height ? height * 0.75 : 0;
    if (tamWidth > maxW || tamHeight > maxH) {
        tamWidth = tamWidth * 0.9;
        tamHeight = tamHeight * 0.9;
    }
    const posIni_X = (maxW - tamWidth) / 2;

    docGrafico.addImage(imgGrafico, 'png', posIni_X >= 0 ? posIni_X : 0, y + 90, tamWidth != 0 ? tamWidth : null, tamHeight != 0 ? tamHeight : null);
    docGrafico.addPage();
}

exports.salvarGrafico = function (nome) {
    if (typeof docGrafico.putTotalPages === 'function') {
        docGrafico.putTotalPages(totalPagesExp);
    }
    docGrafico.save(nome);
};



//////////////////
// WEBPACK FOOTER
// /app/src/app/services/pdf.js
// module id = ../../../../../src/app/services/pdf.js
// module chunks = main